export const APP_STATE = 'DASHBOARD::APP_STATE';
export const DASHBOARD_ERROR = 'DASHBOARD::ERROR';
export const DEVICE_TYPE = 'DASHBOARD::DEVICE_TYPE';
export const EQUIPMENT_TYPE = 'DASHBOARD::EQUIPMENT_TYPE';
export const PLATFORM = 'DASHBOARD::PLATFORM';
export const WEBVIEW_ERROR = 'DASHBOARD::WEBVIEW_ERROR';
export const WEBVIEW_ERROR_MSG = 'DASHBOARD::WEBVIEW_ERROR_MSG';
